import { Stack } from "expo-router";

/* No need to show the header for the child layout, we will use the header (which is static) and back button from the parent layout */

export default function ChildLayout() {
    return (
        <Stack
            screenOptions={{
                headerShown: false,
            }}
        />
    );
}
